/*
eWorldES Proprietary Software
Copyright (C) 2025 eWorldES. All rights reserved.

This software is proprietary to eWorldES and is protected by copyright laws and international treaties.
You may not use, copy, modify, distribute, or disclose this software without explicit written permission from eWorldES.
Any unauthorized use or reproduction of this software is strictly prohibited and may result in legal action.

License Agreement:
By using this software, you agree to be bound by the terms of the eWorldES Proprietary Software License Agreement.
For a copy of the agreement, visit https://eworldes.com/ or contact eWorldES directly for more information.

This software is provided "AS IS" without warranty of any kind, express or implied, including but not limited to the warranties of
merchantability, fitness for a particular purpose, or non-infringement. In no event shall eWorldES be liable for any damages
arising out of the use of this software, even if eWorldES has been advised of the possibility of such damages.

For inquiries or requests regarding this software, please contact eWorldES at:
Email: info@eworldes.com
Website: https://eworldes.com/
*/
const storage = window.localStorage;

const Storage = {
  isSupported() {
    const testKey = "test";
    try {
      storage.setItem(testKey, "1");
      storage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  },
  clear() {
    const sessionExpireFlat = storage.getItem("sessionAutoExpireMsg");
    storage.clear();
    storage.setItem("sessionAutoExpireMsg", sessionExpireFlat || "");
  },
  saveUser(user: any) {
    try {
      storage.setItem("user", JSON.stringify(user));
    } catch (error) {
      console.log("error", error);
    }
  },
  loadUser() {
    try {
      return JSON.parse(storage.getItem("user") || "");
    } catch (error) {
      console.log("error", error);
    }
  },
  deleteUser() {
    try {
      storage.removeItem("user");
    } catch (error) {
      console.log("error", error);
    }
  },
  saveToken(token: string) {
    try {
      storage.setItem("token", token);
    } catch (error) {
      console.log("error", error);
    }
  },
  loadToken() {
    try {
      return storage.getItem("token");
    } catch (error) {
      console.log("error", error);
      return null;
    }
  },
  deleteToken() {
    try {
      storage.removeItem("token");
    } catch (error) {
      console.log("error", error);
    }
  },
  saveUserTimeLog(data: any) {
    try {
      storage.setItem("user_time_log", JSON.stringify(data));
    } catch (error) {
      console.log("error", error);
    }
  },
  loadUserTimeLog() {
    try {
      return storage.getItem("user_time_log");
    } catch (error) {
      console.log("error", error);
      return null;
    }
  },
  deleteUserTimeLog() {
    try {
      storage.removeItem("user_time_log");
    } catch (error) {
      console.log("error", error);
    }
  },
  setLoginMsgFlag(flag: any) {
    try {
      storage.setItem("sessionAutoExpireMsg", flag);
    } catch (error) {
      console.log("error", error);
    }
  },
  getLoginMsgFlag() {
    try {
      return storage.getItem("sessionAutoExpireMsg") || "";
    } catch (error) {
      return null;
    }
  },
  setAutoLoginFlag(flag: any) {
    try {
      storage.setItem("sessionAutoExpire", flag);
    } catch (error) {
      console.log("error", error);
    }
  },
  getAutoLoginFlag() {
    try {
      return storage.getItem("sessionAutoExpire") || "";
    } catch (error) {
      return null;
    }
  },
};

if (!Storage.isSupported()) {
  console.log(
    "Your browser does not support sessionStorage. Don't worry. The app can work without it.",
  );
}

export default Storage;
